import { useEffect } from "react";
import { useProductStore } from "../stores/useProductStores";
import { useCartStore } from "../stores/useCartStores";

const SYNC_INTERVAL_MS = 15000;

export const useInventorySync = () => {
  const syncInventory = useProductStore((state) => state.syncInventory);

  useEffect(() => {
    let active = true;
    let running = false;

    const synchronize = async () => {
      if (!active || running) {
        return;
      }

      running = true;

      try {
        await syncInventory();

        const cartStore = useCartStore.getState();
        if (cartStore.cartItems.length > 0) {
          await cartStore.getCartProducts();
        }
      } finally {
        running = false;
      }
    };

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        synchronize();
      }
    };

    synchronize();

    const intervalId = window.setInterval(
      synchronize,
      SYNC_INTERVAL_MS
    );

    window.addEventListener("focus", synchronize);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      active = false;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", synchronize);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [syncInventory]);
};
